module.exports = __webpack_public_path__ + "img/lte.947610b1.png";